export enum types {
  SET_USER = "SET_USER",

  GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST",
  GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS",
  GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE",

  UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST",
  UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS",
  UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE",

  SET_BOARDS = "SET_BOARDS",
  
  SET_FAVOURITES = "SET_FAVOURITE",
}

export interface ActionProps {
  type: string
  payload?: any
}
